import React, { useState, useRef } from 'react';
import { bumexFeaturesKeys } from '@panel/core/src/constants/bumexFeatures';
import { useTranslation } from 'react-i18next';
import { useOutsideClick, sendTrackingInfo } from '@panel/commons';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';
import { useSelector } from 'react-redux';
import {
  ContentLayout,
  ContainerDropdown,
  CollapsedDropdownTabs,
  TabSection,
  Chevron,
  OpenDropdownTabs,
  ListTabs,
  Separator
} from './styles';
import TabSelector from '../../TabSelector';
import RendimientoIcon from '../../../assets/icons/rendimientoIcon.svg';
import ProductosIcon from '../../../assets/icons/productosIcon.svg';
import ReputaciónIcon from '../../../assets/icons/reputacionIcon.svg';
import ReputaciónIconDisabled from '../../../assets/icons/reputacionIconDisabled.svg';
import DemandaIcon from '../../../assets/icons/demandaIcon.svg';
import ValoresIcon from '../../../assets/icons/valoresIcon.svg';

const icons = {
  performance: { icon: RendimientoIcon },
  reputation: { icon: ReputaciónIcon, disabled: ReputaciónIconDisabled },
  score: { icon: ReputaciónIcon, disabled: ReputaciónIconDisabled },
  products: { icon: ProductosIcon },
  demand: { icon: DemandaIcon },
  values: { icon: ValoresIcon }
};

const Tabs = ({ isDesktop, isAdmin, currentTab, setCurrentTab, setQueryTab, userIsParticular }) => {
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const isPortalWithNewReputation = bumexFeatures.get(bumexFeaturesKeys.NEW_REPUTATION_SECTION);
  const { t } = useTranslation();
  const [activeDropdown, setActiveDropdown] = useState(false);
  const listRef = useRef(null);
  const onClose = () => {
    if (activeDropdown) {
      setActiveDropdown(false);
    }
  };
  useOutsideClick(listRef, onClose);

  const getTabsOptions = () => {
    const options = [];
    if (isPortalWithNewReputation && !userIsParticular) {
      // todos menos particualares y seekers
      options.push('score');
    }

    if (isAdmin) {
      options.push('performance'); // solo admin y supervisor y no particulares
    }

    if (isAdmin && bumexFeatures.get(bumexFeaturesKeys.ESTADISTICAS_REPUTACION) && !isPortalWithNewReputation) {
      // admin y que este habilitada por la bf
      options.push('reputation');
    }

    return options;
  };

  return (
    <ContentLayout isDesktop={isDesktop}>
      {isDesktop ? (
        getTabsOptions().map(tab => {
          return (
            <TabSelector
              key={tab}
              data={tab}
              isSelected={currentTab === tab}
              setSelectTab={setCurrentTab}
              icon={icons[tab].icon}
              isAdmin={isAdmin}
              setQueryTab={setQueryTab}
              withoutCursorPointer={!isAdmin || getTabsOptions().length < 2}
              isPortalWithNewReputation={isPortalWithNewReputation}
            />
          );
        })
      ) : (
        <ContainerDropdown width='100%'>
          <CollapsedDropdownTabs
            onClick={e => {
              e.stopPropagation();
              if (isAdmin && getTabsOptions().length > 1) setActiveDropdown(!activeDropdown);
            }}
          >
            <TabSection>
              <img
                src={icons[currentTab].icon}
                alt='icos-chevron'
                data-panel={`panel-estadisticas-tabLabel-icon-${currentTab}`}
              />
              <div data-panel={`panel-estadisticas-tabLabel-${currentTab}`}>
                {t(`panel.estadisticas.leftBar.title.${currentTab}`)}
              </div>
            </TabSection>
            <Chevron
              active={activeDropdown}
              disabled={!isAdmin || getTabsOptions().length < 2}
              data-panel='panel-estadisticas-reputación-dropdownChevron'
            />
          </CollapsedDropdownTabs>
          <OpenDropdownTabs active={activeDropdown} ref={listRef}>
            {getTabsOptions().map((tab, i) => {
              return (
                <ListTabs
                  key={tab}
                  onClick={() => {
                    if (isAdmin) {
                      setActiveDropdown(false);
                      if (tab !== currentTab) {
                        setCurrentTab(tab);
                        setQueryTab(tab);
                        sendTrackingInfo(
                          'Panel',
                          'Estadisticas',
                          `Ir a ${t(`panel.estadisticas.leftBar.title.${tab}`)}`
                        );
                      }
                    }
                  }}
                >
                  <TabSection>
                    <img
                      src={icons[tab].icon}
                      alt={`Icon-${tab}`}
                      data-panel={`panel-estadisticas-tabLabelOpen-icon-${currentTab}`}
                    />
                    <div data-panel={`panel-estadisticas-tabLabelOpen-${currentTab}`}>
                      {t(`panel.estadisticas.leftBar.title.${tab}`)}
                    </div>
                  </TabSection>
                  {i !== getTabsOptions().length - 1 && <Separator />}
                </ListTabs>
              );
            })}
          </OpenDropdownTabs>
        </ContainerDropdown>
      )}
    </ContentLayout>
  );
};

export default Tabs;
